import { Injectable } from "@angular/core";
import { BaseClient } from "../base-client/base-client";
import { IBaseClient } from "../base-client/interface";

@Injectable({
  providedIn: 'root'
})
export class UnknownClient extends BaseClient implements IBaseClient {
  constructor() {
    super();
  }

  override showCardDetailsSubmit = false;
  override validClient: boolean = false;
}
